export class ReactivateSimulationResponsev2 {

    ReactivatePossible: string;
    ReactivateNotPossibleReason: string;
    InGraceReactivation: boolean;
    ProductPrice: number;
    SetupPrice: number;
    YARDPrice: number;
    TotalPrice: number;
    NextBillingDate: Date;

    Credit: number;

    TaxFromCache: boolean;
    TaxEnabled: boolean;
    TaxRate: number;
    TaxAmount: number;
    State: string;
    TotalWithTax: number;
    TaxRateDisplay: string;
 

    // public static FixDates(item: ReactivateSimulationResponsev2) {
    //     item.NextBillingDate = new Date(item.NextBillingDate);
    // }

}